import CryptoJS from 'crypto-js';

const secretKey = 'e9NHdT3GU6wBdWlw3RTqvrShGzyerRl4BaMhFeUI3v4j6U0opW5a19HQHDAHHCrhYXq8oG6D'; 

const apiKey = process.env.REACT_APP_API_URL;



class Game {

   
    static encryptData(data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    }

   
    static encryptEndpoint(endpoint) {
        return CryptoJS.AES.encrypt(endpoint, secretKey).toString();
    }

    static decryptData(encryptedData) {
        const secretKey = 'e9NHdT3GU6wBdWlw3RTqvrShGzyerRl4BaMhFeUI3v4j6U0opW5a19HQHDAHHCrhYXq8oG6D';
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8); 
        return JSON.parse(decryptedData);
    }
    
    static async getGameInfo(game_id) {
        const encryptedPayload = this.encryptData({ game_id });
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_GAME_INFO_BY_ID');

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getProviderByGame(game_id, user_id) {
        const encryptedPayload = this.encryptData({ARG: { game_id, user_id }});
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_PROVIDER_INFO_BY_GAME_ID');

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getGames(USER_ID,CATEGORY_SLUG,LIMIT,PAGE) {

        const encryptedPayload = this.encryptData({ ARG: { USER_ID, CATEGORY_SLUG, LIMIT, PAGE } });
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_POPULAR_GAME_BY_CATEGORY_ID'); 

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

      

        return this.decryptData(responseData.data);
        
    }



    static async getProvider(USER_ID,CATEGORY_SLUGS,LIMIT,PAGE) {

        const encryptedPayload = this.encryptData({ ARG: { USER_ID, CATEGORY_SLUGS, LIMIT_PER_CATEGORY:LIMIT, PAGE } });
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_PROVIDERS_LIST'); 

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }



    static async getGamesByProviderId(USER_ID,PROVIDER_ID,LIMIT,PAGE) {

        const encryptedPayload = this.encryptData({ ARG: { USER_ID, PROVIDER_ID,CATEGORY_SLUG:"casino", LIMIT:LIMIT, PAGE } });
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_GAME_BY_PROVIDER_ID'); 

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });
        
        const responseData = await response.json();
        return this.decryptData(responseData.data);
        
    }



    static async getGamesBySubCategory(USER_ID, CATEGORY_SLUG, SUBCATEGORY_SLUG, LIMIT, PAGE) {

        const encryptedPayload = this.encryptData({ ARG: { USER_ID, CATEGORY_SLUG, SUBCATEGORY_SLUG, LIMIT:LIMIT, PAGE } });
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_GAME_BY_SUBCATEGORY'); 

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });
        
        const responseData = await response.json();
        return this.decryptData(responseData.data);
        
    }



    static async getProviderActive(USER_ID,CATEGORY_SLUG) {

        const encryptedPayload = this.encryptData({ ARG: { USER_ID,CATEGORY_SLUG,TOKEN:"1" } });
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_PROVIDERS_ACTIVE'); 
        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 

        });
    
        const responseData = await response.json();

        return this.decryptData(responseData.data);        
    }


    static async getProviderGame(USER_ID, PROVIDER_ID, LIMIT, PAGE, CATEGORY_SLUG = '', CATEGORY_ID = '') {
        // Формуємо аргументи динамічно, в залежності від наявності CATEGORY_SLUG та CATEGORY_ID
        const ARG = {
            USER_ID,
            PROVIDER_ID,
            LIMIT,
            PAGE,
        };
    
        // Додаємо CATEGORY_ID, якщо він є
        if (CATEGORY_ID) {
            ARG.CATEGORY_ID = CATEGORY_ID;
        }
    
        // Додаємо CATEGORY_SLUG, якщо він є
        if (CATEGORY_SLUG) {
            ARG.CATEGORY_SLUG = CATEGORY_SLUG;
        }
    
        const encryptedPayload = this.encryptData({ ARG });
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_PROVIDERS_GAME_BY_ID_V3');
    
        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }),
        });
    
        const responseData = await response.json();
    
        return this.decryptData(responseData.data);
    }
    


    static async searchGame(NAME,CATEGORY_SLUG,LIMIT,PAGE) {

        const encryptedPayload = this.encryptData({ ARG: { NAME,CATEGORY_SLUG,LIMIT,PAGE } });


        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/SEARCH_GAME_BY_NAME'); 

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
        
    }


    static async check_promo_by_game(currency,game_id,user_id) {

        const encryptedPayload = this.encryptData({game_id,currency,user_id});


        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/CHECK_PROMO_BY_GAME'); 

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
        
    }


    static async UPDATE_USER_BALANCE_TYPE(user_id,type) {

        const encryptedPayload = this.encryptData({user_id,type});


        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/UPDATE_USER_BALANCE_TYPE'); 

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
        
    }

    static async searchGameFrame(NAME,CATEGORY_SLUG,LIMIT,PAGE, USER_ID) {

        const encryptedPayload = this.encryptData({ ARG: { NAME,CATEGORY_SLUG,LIMIT,PAGE,USER_ID } });

        
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/SEARCH_GAME_BY_NAME_V3'); 

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

 
        const responseData = await response.json();

        return this.decryptData(responseData.data);
        
    }


    static async getJackPot(CURRENCY) {

        const encryptedPayload = this.encryptData({ ARG: { CURRENCY } });



        const encryptedEndpoint = this.encryptEndpoint('/SkinsController/GET_JAKPOTS_BY_SKINID'); 



        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }


    static async openGame(CURRENCY,game_id,user_id, lang){

        const encryptedPayload = this.encryptData({ CURRENCY,game_id,user_id,lang });
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/playgame'); 


        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
       
    }

    
    static async GET_ALL_PROVIDERS(USER_ID){

        const encryptedPayload = this.encryptData({ ARG:{USER_ID} });

     

        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_PROVIDERS_LIST_ALL'); 



        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
       
    }



    static async getBestWin(SELECTION = '',CURRENCY){

        const encryptedPayload = this.encryptData({ ARG:{SELECTION,CURRENCY} });

     

        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_BEST_WINS'); 



        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
       
    }


    
    static async authSport(currency,language,page,user_id,v2){

        // console.log('currency:', currency, 'language:', language, 'page:', page, 'user_id:', user_id, 'v2:', v2);
        

        const encryptedPayload = this.encryptData({ currency,language,page,user_id,v2 });

     

        const encryptedEndpoint = this.encryptEndpoint('/Sport_GSsystem/AUTH_USER'); 



        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
       
    }

    static async authSportbook(USER_ID){

        const SPORT_ID = 100;

        const encryptedPayload = this.encryptData({ ARG: {USER_ID, SPORT_ID} });

     

        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/AUTH_SPORTBOOK'); 



        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }), 
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
       
    }


    static async getGameByCategory(CATEGORY_SLUG = '', LIMIT = 30, PAGE = 1, USER_ID = "") {
        const encryptedPayload = this.encryptData({
            ARG: {
                CATEGORY_SLUG,
                LIMIT,
                PAGE,
                USER_ID
            }
        });
    
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_GAMES_BY_CATEGORY_V3');
    
        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }),
        });
    
        const responseData = await response.json();
    
        return this.decryptData(responseData.data);
    }


    static async getLastGames(USER_ID, CATEGORY_SLUG,LIMIT, PAGE) {
        const encryptedPayload = this.encryptData({
            ARG: {
                CATEGORY_SLUG,
                USER_ID,
                LIMIT,
                PAGE
            }
        });
    
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_LAST_GAMES');
    
        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }),
        });
    
        const responseData = await response.json();
    
        return this.decryptData(responseData.data);
    }


    static async getFavoriteGames(USER_ID, CATEGORY_SLUG, LIMIT, PAGE) {
        const encryptedPayload = this.encryptData({
            ARG: {
                CATEGORY_SLUG,
                USER_ID,
                LIMIT,
                PAGE
            }
        });
    
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/GET_FAVORITE_GAMES');
    
        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }),
        });
    
        const responseData = await response.json();
    
        return this.decryptData(responseData.data);
    }


    static async updateLastGames(USER_ID, CATEGORY_SLUG, LAST_GAME_ID) {
        const encryptedPayload = this.encryptData({
            ARG: {
                CATEGORY_SLUG,
                USER_ID,
                LAST_GAME_ID,
            }
        });
    
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/UPDATE_LAST_GAMES');
    
        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }),
        });
    
        const responseData = await response.json();
    
        return this.decryptData(responseData.data);
    }

    static async updateFavoriteGames(USER_ID, CATEGORY_SLUG, GAME_ID) {
        const encryptedPayload = this.encryptData({
            ARG: {
                CATEGORY_SLUG,
                USER_ID,
                GAME_ID,
            }
        });
    
        const encryptedEndpoint = this.encryptEndpoint('/SkinApiV2/UPDATE_FAVORITE_GAMES');
    
        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: encryptedPayload, endpoint: encryptedEndpoint }),
        });
    
        const responseData = await response.json();
    
        return this.decryptData(responseData.data);
    }

}

export default Game;


